let store = {
  teacherId: localStorage.getItem('teacher_id'),
  teacherName:"",
  modules: []
};

export const setTeacherId = (id) => {
  store.teacherId = id;
  localStorage.setItem('teacher_id', id);
};
export const getTeacherId = () => {
  // Always read from localStorage to get the latest value
  const teacherId = localStorage.getItem('teacher_id');
  // Convert to number, return 0 if null or invalid
  return teacherId ? parseInt(teacherId, 10) : 0;
};


export const setTeacherName = (name) => {
  store.teacherName = name;
};
export const getTeacherName = () => store.teacherName;


export const setModules = (modulesArray) => {
  store.modules = modulesArray;
};
export const getModules = () => store.modules;
